import { render, staticRenderFns } from "./ValvalueGrid.vue?vue&type=template&id=905fde5e"
import script from "./ValvalueGrid.vue?vue&type=script&lang=js"
export * from "./ValvalueGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports